// Listens for the successful “login” action and calls reload functions
export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  const orderHistoryStore = useOrderHistoryStore()

  userStore.$onAction(({ name, after }) => {
    if (name === 'login') {
      after(async () => {
        if (userStore.isAuthenticated) {
          await orderHistoryStore.reloadOrders()
          await orderHistoryStore.reloadFrequentOrders()
        }
      })
    }
  })
})
